// ABOUTME: Composes WhatsApp pre-registration configuration editing sections.
// ABOUTME: Passes one normalized configuration through focused domain editors.
import React from "react";
import { Grid } from "@material-ui/core";

import WhatsappPreRegistrationAssignmentEditor from "./WhatsappPreRegistrationAssignmentEditor";
import WhatsappPreRegistrationCompanyResponderEditor from "./WhatsappPreRegistrationCompanyResponderEditor";
import WhatsappPreRegistrationConfigBasics from "./WhatsappPreRegistrationConfigBasics";
import WhatsappPreRegistrationMessageCopy from "./WhatsappPreRegistrationMessageCopy";
import WhatsappPreRegistrationRegionStoreEditor from "./WhatsappPreRegistrationRegionStoreEditor";
import WhatsappPreRegistrationRoutingEditor from "./WhatsappPreRegistrationRoutingEditor";
import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import {
    WhatsappPreRegistrationConfig,
    WhatsappPreRegistrationOptions
} from "./whatsappPreRegistrationSettingsModel";

interface WhatsappPreRegistrationConfigEditorProps {
    config: WhatsappPreRegistrationConfig;
    activeConfig: WhatsappPreRegistrationConfig;
    options: WhatsappPreRegistrationOptions;
    labels: WhatsappPreRegistrationLabels;
    createFlowModelLabel: string;
    isDirty: boolean;
    onChange: (config: WhatsappPreRegistrationConfig) => void;
}

const WhatsappPreRegistrationConfigEditor = ({
    config,
    activeConfig,
    options,
    labels,
    createFlowModelLabel,
    isDirty,
    onChange
}: WhatsappPreRegistrationConfigEditorProps) => (
    <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
            <WhatsappPreRegistrationConfigBasics
                config={config}
                activeConfig={activeConfig}
                options={options}
                labels={labels}
                createFlowModelLabel={createFlowModelLabel}
                isDirty={isDirty}
                onChange={onChange}
            />
        </Grid>
        <Grid item xs={12} md={7}>
            <WhatsappPreRegistrationMessageCopy
                config={config}
                labels={labels}
                onChange={onChange}
            />
        </Grid>
        <Grid item xs={12}>
            <WhatsappPreRegistrationRoutingEditor
                config={config}
                stores={options.stores}
                labels={labels}
                onChange={onChange}
            />
        </Grid>
        {config.routingMode === "REGION_BRANCH" && (
            <Grid item xs={12}>
                <WhatsappPreRegistrationRegionStoreEditor
                    config={config}
                    stores={options.stores}
                    labels={labels}
                    onChange={onChange}
                />
            </Grid>
        )}
        <Grid item xs={12}>
            {config.routingMode === "COMPANY" ? (
                <WhatsappPreRegistrationCompanyResponderEditor
                    config={config}
                    users={options.users}
                    labels={labels}
                    onChange={onChange}
                />
            ) : (
                <WhatsappPreRegistrationAssignmentEditor
                    config={config}
                    options={options}
                    labels={labels}
                    onChange={onChange}
                />
            )}
        </Grid>
    </Grid>
);

export default WhatsappPreRegistrationConfigEditor;
